import { MutableRefObject, useEffect } from 'react'

const useClickOutsideV2 = (refs: MutableRefObject<HTMLElement | null>[], callback: (e: MouseEvent) => void) => {
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      const isClickOutsideAllRefs = refs.every(
        ref => ref.current && e.target && !ref.current.contains(e.target as Node),
      )

      if (isClickOutsideAllRefs) {
        callback(e)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [refs, callback])
}

export default useClickOutsideV2
